/**
 * @fileoverview GET handler for the "/engagement/prediction_data(/:prediction_id)" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementPrediction } from "./constants";
import type { EngagementPredictionResult } from "./types";

export const getEngagementPrediction = reactQueryFetcherAdapter(
  engagementPrediction,
  (signal: AbortSignal, predictionId: string): Promise<EngagementPredictionResult> => {
    return fetch(`/engagement/prediction_data/${predictionId}`, "GET", {}, { signal });
  }
);
